import { View, Image, useWindowDimensions, ScrollView } from "react-native";
import RenderHTML from "react-native-render-html";
import { customStyles } from "../../theme/styles"
import React from 'react'

const HowToClaim = (props:any) => {
    let data = props.data

    const { width } = useWindowDimensions()

    let html = data["how_to_claim"]


    let tagStyle = {
        span: {
            fontFamily: "Raleway_400Regular",
            marginBottom: 10
        },

        ul: {
            color: '#3BAA90',
        }
    }
  return (
    <View style={customStyles.htmlContainer}>
            <Image style={customStyles.infoImagesStyle} source={require("../../assets/how_it_works.png")} />

            <ScrollView contentInsetAdjustmentBehavior="automatic">
                <View style={customStyles.htmlContent}>
                    <RenderHTML
                        tagsStyles={tagStyle}
                        contentWidth={width}
                        source={{ html: html }}
                    />
                </View>
            </ScrollView>
        </View>
  )
}


export default HowToClaim
